import React, { Component } from "react";

class Map extends Component {
  render() {
    return (
      <div className="google-map container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div
              style={{
                width: "100%",
                height: "700px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31213.37989467975!2d77.29924522138668!3d11.107936100000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba907863cae6021%3A0x8a51aa33ea3b5ba1!2sCheran%20Properties!5e0!3m2!1sen!2sin!4v1704465600000!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Cheran Properties Location"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Map;
